import { Parse } from 'parse';

Parse.initialize(process.env.REACT_APP_APP_ID, null, process.env.REACT_APP_MASTER_KEY);
Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
Parse.serverURL = process.env.REACT_APP_SERVER_URL;

export const gameRecordsExports = async (params) => {
  const filter = params;

  const Resource = Parse.Object.extend('GameCatalogue');
  const query = new Parse.Query(Resource);
  query.descending('createdAt');
  query.include('building');

  filter &&
    Object.keys(filter).map((f) =>
      typeof filter[f] === 'string' ? query.matches(f, filter[f], 'i') : query.equalTo(f, filter[f])
    );
  try {
    const results = await query.find();
    return {
      data: results.map((o) => {
        const building = o.get('building');
        return {
          id: o.id,
          ...o.attributes,
          buildingName: building ? building.get('name') : null
        };
      })
    };
  } catch (error) {
    return { error: 'Failed to generate gameRecordsExports.' };
  }
};
